module.exports = __webpack_public_path__ + "img/company_6.210f8b72.png";